import SearchMomentModel from './SearchMoment.model';

export default class SearchsMomentsModel {
  constructor({
    searches: {
      chatbot,
      links,
    },
  } = { searches: {} }) {
    this.chatbot = chatbot;
    this.links = links?.map((link) => new SearchMomentModel(link));
  }

  hasChatbot() {
    return !!this.chatbot;
  }

  getLinks() {
    return this.links || [];
  }
}
